import {connect} from "react-redux";
import {useHistory, useLocation, useParams} from "react-router-dom";
import {Alert, Col} from "reactstrap";
import React, {useState} from "react";
import {Store} from "../../../../../store";
import {changeOpcoesResultado, changeSearch} from "../../../../../store/ducks/pesquisa";
import {ConsultaHelper} from "../../../../../shared/helpers";
import {addAllItensCesta, setarItensCesta} from "../../../../../store/ducks/cesta";
import {useTranslation} from "react-i18next";

const SeletorRepositorios = React.lazy(() => import("../../../components/Home/SeletorRepositorios"))
const FiltroEsquerdo = React.lazy( () => import("../../../components/Home/FiltroEsquerdo"))
const PaginaDireitaHeader = React.lazy( () => import("../../../components/Home/PaginaDireitaHeader"))
const PaginaDireita = React.lazy( () => import("../../../components/Home/PaginaDireita"))

/**
 *
 * @param guiasPesquisaRx
 * @param cestaRx
 * @param opcoesResultadoRx
 * @param consultaRx
 * @param itensConsulta
 * @param selectAll
 * @param toggleSelectAll
 * @returns {JSX.Element}
 * @constructor
 */
const ConteudoPesquisaGeral = ({ guiasPesquisaRx, cestaRx, opcoesResultadoRx, consultaRx, itensConsulta, selectAll, toggleSelectAll}) => {
    const location = useLocation()
    const history = useHistory();
    const  { guia = null } = useParams();

    const guiaSelecionada = guia || (guiasPesquisaRx && guiasPesquisaRx?.length && guiasPesquisaRx.find(guia => guia.ordem === 0)?.codigo);
    const { t } = useTranslation()
    const alterarOrdemCresDesc = value => {
        Store.dispatch(
            changeOpcoesResultado({
                ...opcoesResultadoRx,
                ordenacao: value,
                paginaAtiva: 1,
            }),
        );
    };


    const selecionarTodosCesta = e => {
        toggleSelectAll(e.target.checked);

        if (e.target.checked) {
            const array = [...itensConsulta].filter(
                itemC =>
                    !cestaRx.find(item => itemC.cod_acervo === item.cod_acervo),
            );
            Store.dispatch(addAllItensCesta(array));
        } else {
            const array = [...cestaRx].filter(
                item =>
                    !itensConsulta.find(
                        itemC => itemC.cod_acervo === item.cod_acervo,
                    ),
            );
            Store.dispatch(setarItensCesta(array));
        }
    };


    return (<>
        <Col
            md="3"
            xs="12"
            className="b-w1 b-tema50 pt-3 pl-2 pr-2"
        >
            {guiaSelecionada === 'pesquisa_geral' && (
                <SeletorRepositorios
                    guiaSelecionada={guiaSelecionada}
                    location={location}
                    history={history}
                />
            )}
            <FiltroEsquerdo
                guiaPesquisa={guiaSelecionada}
            />
        </Col>
        <Col
            xs="12"
            md="9"
            className="pr-0 border-left b-w1 b-tema50"
        >
            <PaginaDireitaHeader
                alterarOrdemCresDesc={alterarOrdemCresDesc}
                selecionarTodosCesta={selecionarTodosCesta}
                selectAll={selectAll}
                toggleSelectAll={toggleSelectAll}
                cestaRx={cestaRx}
                opcoesResultadoRx={opcoesResultadoRx}
                itensConsulta={itensConsulta}
            />
            {
                itensConsulta.length === 0 && (
                    <Col xs="12" md="12" className="pr-0 b-tema50">
                        <div className="mt-3 container">
                            <Alert color="warning" className="p-3">
                                <h4 className="alert-heading">
                                    {t('NenhumResultadoEncontrado')}
                                </h4>
                                <p className="mb-2">
                                    {t('SuaPesquisaNenhumRegistro')}
                                </p>
                                <p className="mb-0 s13">
                                    {t('SuaPesquisaNenhumRegistro2')}
                                </p>
                            </Alert>
                        </div>
                    </Col>
                ) || (
                    <PaginaDireita
                        itensConsulta={itensConsulta}
                        guiaPesquisa={guiaSelecionada}
                    />
                )
            }
        </Col>
    </>)
}

const mapStateToProps = state => ({
    guiasPesquisaRx: state.pageConfig.guiasPesquisa,
    consultaRx : state.pesquisa.consulta,
    cestaRx: state.cesta.itens,
    opcoesResultadoRx: state.pesquisa.opcoesResultado,
});


export default connect(mapStateToProps)(ConteudoPesquisaGeral);
